const digest = '521b26ffe4fc52cf4a438b5062b495b7e7da956e1ef8ec53ba7bd6a3f048b656';
const css = `._noWrapButton_1qcqk_1>div>button{cursor:pointer;min-width:0!important;white-space:nowrap}@media (max-width:799px){._noWrapButton_1qcqk_1>div>button{cursor:pointer;min-width:0;overflow-wrap:anywhere;white-space:normal;word-break:break-word}}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'noWrapButton': '_noWrapButton_1qcqk_1' };
export const noWrapButton = '_noWrapButton_1qcqk_1';
export { css, digest };